var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPastePrimary1616 = function SvgPastePrimary1616(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#669AFF",
    d: "M11 .667H3c-.733 0-1.333.6-1.333 1.333v9.333H3V2h8zm2 2.666H5.667c-.734 0-1.334.6-1.334 1.334V14c0 .733.6 1.333 1.334 1.333H13c.733 0 1.333-.6 1.333-1.333V4.667c0-.734-.6-1.334-1.333-1.334M13 14H5.667V4.667H13z"
  })));
};
export default SvgPastePrimary1616;